import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { PrintablePlayerSortName } from '@sorare/core/src/contexts/config';

import { PageTemplate } from '@sorare/marketplace/src/components/market/PageTemplate';
import { useScoutingCenterSo5Fixture } from '@sorare/marketplace/src/hooks/useScoutingCenterSo5Fixture';
import { scoutingCenterMarketFilters } from '@sorare/marketplace/src/searchCommonPlayer/filtersGroup/nba';

import { NBAPlayerSearch } from 'components/searchCards/NBAPlayerSearch';

import { Header } from './Header';

const SORTS: PrintablePlayerSortName[] = [
  'DESC-L10',
  'ASC-L10',
  'DESC-name_for_sorting',
  'ASC-name_for_sorting',
  'DESC-next_classic_fixture_projected_score',
  'ASC-next_classic_fixture_projected_score',
  'DESC-next_daily_fixture_projected_score',
  'ASC-next_daily_fixture_projected_score',
  'ASC-points',
  'DESC-points',
  'ASC-assists',
  'DESC-assists',
  'ASC-rebounds',
  'DESC-rebounds',
  'ASC-blocks',
  'DESC-blocks',
  'ASC-double_double',
  'DESC-double_double',
  'ASC-average_mins_played',
  'DESC-average_mins_played',
  'ASC-steals',
  'DESC-steals',
  'ASC-three_points_made',
  'DESC-three_points_made',
  'ASC-triple_double',
  'DESC-triple_double',
  'ASC-turnovers',
  'DESC-turnovers',
];

export const ScoutingCenter = () => {
  const so5FixtureSlug = useScoutingCenterSo5Fixture(Sport.NBA);
  return (
    <PageTemplate showBack>
      <Vertical gap={3}>
        <Header />
        <div>
          <NBAPlayerSearch
            sorts={SORTS}
            defaultSort={SORTS[0]}
            cardFilters={scoutingCenterMarketFilters}
            analyticsTags={['Scouting-center', 'NBA']}
            topic={{ type: 'scoutingCenter', label: '' }}
            attributesToRetrieve={['slug']}
            so5FixtureSlug={so5FixtureSlug}
          />
        </div>
      </Vertical>
    </PageTemplate>
  );
};
